/* Kaleo PDP gallery (KW-010): main media + thumbnail strip with
   prev/next chevrons. Clicking a thumb (or a chevron) swaps the main
   image and keeps the active thumb in view. Scrolling is confined to
   the thumb strip (no page jumps); smooth behavior respects
   prefers-reduced-motion. */
(() => {
  class KaleoGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-kaleo-gallery-main]');
      this.list = this.querySelector('[data-kaleo-gallery-list]');
      this.thumbs = Array.from(this.querySelectorAll('[data-kaleo-gallery-thumb]'));
      if (!this.main || this.thumbs.length === 0) return;

      this.index = Math.max(
        0,
        this.thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true')
      );

      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.select(i));
      });
      const prev = this.querySelector('[data-kaleo-gallery-prev]');
      const next = this.querySelector('[data-kaleo-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.select(this.index - 1));
      if (next) next.addEventListener('click', () => this.select(this.index + 1));
    }

    select(index) {
      this.index = (index + this.thumbs.length) % this.thumbs.length;
      const thumb = this.thumbs[this.index];

      this.main.src = thumb.dataset.fullSrc;
      if (thumb.dataset.fullSrcset) {
        this.main.srcset = thumb.dataset.fullSrcset;
      } else {
        this.main.removeAttribute('srcset');
      }
      this.main.alt = thumb.dataset.alt || '';
      if (thumb.dataset.fullWidth && thumb.dataset.fullHeight) {
        this.main.width = thumb.dataset.fullWidth;
        this.main.height = thumb.dataset.fullHeight;
      }

      this.thumbs.forEach((t, i) => {
        t.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });

      if (this.list && this.list.scrollWidth > this.list.clientWidth) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const target = thumb.offsetLeft - (this.list.clientWidth - thumb.offsetWidth) / 2;
        this.list.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
  }

  if (!customElements.get('kaleo-gallery')) {
    customElements.define('kaleo-gallery', KaleoGallery);
  }
})();
